// extracted by mini-css-extract-plugin
export default {"SubscribeButton":"pushnotifications_SubscribeButton__V6VTv"};